export const BRIEF_TIME = "6:02 AM";

export const ITEMS = [
  {
    id: "lead-1",
    pill: "New lead",
    pillColor: "#0B3D5C",
    title: "Sara Whitfield · re-roof estimate, 2841 Birch Hill",
    meta: "Inbound · last night 11:47 PM",
    draft:
      "Hi Sara — thanks for the photos. I can be at the property Thursday morning around 8 AM for a 20-minute look. If that works, reply with the gate code and I'll lock it in. — Tom",
  },
  {
    id: "lead-2",
    pill: "New lead",
    pillColor: "#0B3D5C",
    title: "Marcus Lee · storm damage, 7 Oakridge",
    meta: "Inbound · last night 9:12 PM",
    draft:
      "Hey Marcus — sorry about the wind last night. I've cleared time tomorrow at 2 PM to walk it. If the carrier's already involved, send me the claim number and we'll save a step. — Tom",
  },
  {
    id: "lead-3",
    pill: "New lead",
    pillColor: "#0B3D5C",
    title: "Patel residence · gutter quote",
    meta: "Inbound · this morning 5:31 AM",
    draft:
      "Hi Mr. Patel — measured your fascia run from the photo. Looks like a 110-foot job. Sending the firm quote by noon. Want copper or aluminum? — Tom",
  },
  {
    id: "est-1",
    pill: "Stale estimate",
    pillColor: "#9B6B2F",
    title: "Quote #4188 — Birch Hill, sent 8 days ago",
    meta: "No reply since Tuesday",
    draft:
      "Hey — just checking in on the quote we sent last Tuesday. No pressure either way. If there's a question on the cricket detail or the underlayment, happy to walk it. — Tom",
  },
  {
    id: "est-2",
    pill: "Stale estimate",
    pillColor: "#9B6B2F",
    title: "Quote #4192 — Sterling Ave, sent 9 days ago",
    meta: "Opened twice, no reply",
    draft:
      "Morning Lisa — figured I'd nudge the Sterling Ave quote one more time. If the timing's off, just say the word and I'll close the file. — Tom",
  },
  {
    id: "ar-1",
    pill: "AR aging",
    pillColor: "#7A2E2E",
    title: "Invoice #4192 hit 30 days",
    meta: "Birch Hill Properties · $14,820",
    draft:
      "Hi — just a heads up that invoice 4192 hit 30 days yesterday. If it's already on the next check run, ignore me. Otherwise, here's the pay link. Thanks. — Tom",
  },
  {
    id: "ref-1",
    pill: "Referral opening",
    pillColor: "#0B3D5C",
    title: "Yesterday's 5-star — referral ask drafted",
    meta: "From: happy.customer@gmail.com",
    draft:
      "Thanks for the kind note today, Sara. If anyone on your street is dealing with the same kind of storm damage, we'd appreciate the intro. A quick reply with a name works. — Tom",
  },
];
